// extracted by mini-css-extract-plugin
export default {"warning":"SwitchClinicModal__warning--wEnS1","modal":"SwitchClinicModal__modal--npJkD","ant-modal-body":"SwitchClinicModal__ant-modal-body--nC8x7"};